import { isApiError, isPaywall } from '@/api/errors'
import type { Entitlement } from '@/schemas/subscriptions'

/**
 * The feature key a 403 `SUBSCRIPTION_REQUIRED` names, or null for any other
 * error. Upsell from this key — which plans grant it — and never from
 * `fields.required_tier` (a hard-coded "bull" fallback on every feature gate)
 * or `message` ("This requires the Bull plan." to a Guru member whose plan
 * lacks the flag).
 */
export function subscriptionRequiredFeature(error: unknown): string | null {
  if (!isApiError(error) || !isPaywall(error)) return null
  const value: unknown = error.fields['feature']
  const feature = Array.isArray(value) ? (value[0] as unknown) : value
  return typeof feature === 'string' && feature !== '' ? feature : null
}

/**
 * Whether to draw `featureKey` locked for this member. Only while mm-be
 * ENFORCES: with `enforced` false the server serves every gated endpoint, and
 * a UI that locked on the flags alone would hide what the member can use. A
 * stray 403 can still arrive when the mode flips between reads — handle it
 * where the request is made.
 */
export const isLocked = (me: Entitlement | null | undefined, featureKey: string): boolean =>
  me?.enforced === true && me.features[featureKey]?.enabled !== true
